module.exports = __webpack_public_path__ + "img/nctu.eaf5b31e.png";